import { Location } from '@prisma/client';
import axios from 'axios';

interface GeoAddress {
  housenumber?: string;
  street?: string;
  suburb?: string;
  city?: string;
  county?: string;
  district?: string;
  state?: string;
  postcode?: string;
  country: string;
  country_code: string;
  neighborhood?: string;
  lon: number;
  lat: number;
  state_code?: string;
  formatted: string;
  address_line1?: string;
  address_line2?: string;
  category: string;
  result_type: string;
  place_id: string;
}

export function mapGeoapifyToLocation(
  address: GeoAddress
): Omit<Location, 'id'> {
  return {
    address: address as any,
    translations: {
      en: address as any,
    },
    lat: address.lat,
    lng: address.lon,
  };
}

export async function createLocation(data: Omit<Location, 'id'>) {
  const response = await axios.post('/api/location', data);
  return response.data;
}

export async function updateLocation(id: string, data: Partial<Location>) {
  const response = await axios.patch(`/api/location/${id}`, data);
  return response.data;
}
